import React from 'react';
import {ConfigProvider, Space, Table, Tag} from 'antd';
import styles from './finance-table.module.css'

const {Column, ColumnGroup} = Table;

export const FinanceTable = ({isRevenue = false, tableRowTitleForRevenue, tableRowTitleForOperating}) => {
    const data = [
        {
            key: '1',
            firstName: isRevenue ? tableRowTitleForRevenue[0] : tableRowTitleForOperating[0],
            2018: '2 394 376',
            2019: '2 394 707',
            2020: '1 959 015',
            2021: '2 986 178',
            2022: '3 412 129',
            2023: '3 519 959',
            TTM: '3 557 158,5',
        },
        {
            key: '2',
            firstName: isRevenue ? tableRowTitleForRevenue[1] : tableRowTitleForOperating[1],
            2018: '2 394 376',
            2019: '2 394 707',
            2020: '1 959 015',
            2021: '2 986 178',
            2022: '3 412 129',
            2023: '3 519 959',
            TTM: '3 557 158,5',
        },
        {
            key: '3',
            firstName: isRevenue ? tableRowTitleForRevenue[2] : tableRowTitleForOperating[2],
            2018: '2 394 376',
            2019: '2 394 707',
            2020: '1 959 015',
            2021: '2 986 178',
            2022: '3 412 129',
            2023: '3 519 959',
            TTM: '3 557 158,5',
        },
        {
            key: '4',
            firstName: isRevenue ? tableRowTitleForRevenue[3] : tableRowTitleForOperating[3],
            2018: '2 394 376',
            2019: '2 394 707',
            2020: '1 959 015',
            2021: '2 986 178',
            2022: '3 412 129',
            2023: '3 519 959',
            TTM: '3 557 158,5',
        },
    ];
    return (
        <div className={styles.tableContainer}>
            <ConfigProvider
                theme={{
                    components: {
                        Table: {
                            borderColor: '#DBDBDB',
                            fontFamily: 'Montserrat',
                        }
                    }
                }}
            >
                <Table dataSource={data} pagination={false} className={styles.table}>
                    <Column dataIndex="firstName" key="firstName"/>
                    <Column title={<div className={styles.titleCell}>2018</div>} dataIndex="2018" key="2018"
                            align="center"/>
                    <Column title={<div className={styles.titleCell}>2019</div>} dataIndex="2019" key="2019"
                            align="center"/>
                    <Column title={<div className={styles.titleCell}>2020</div>} dataIndex="2020" key="2020"
                            align="center"/>
                    <Column title={<div className={styles.titleCell}>2021</div>} dataIndex="2021" key="2021"
                            align="center"/>
                    <Column title={<div className={styles.titleCell}>2022</div>} dataIndex="2022" key="2022"
                            align="center"/>
                    <Column title={<div className={styles.titleCell}>2023</div>} dataIndex="2023" key="2023"
                            align="center"/>
                    <Column title={<div className={styles.titleCell}>TTM</div>} dataIndex="TTM" key="TTM"
                            align="center"/>
                </Table>
            </ConfigProvider>
        </div>)
}